import { render } from "./AuPagination.vue?vue&type=template&id=f0e06722"
import script from "./AuPagination.vue?vue&type=script&lang=js"
export * from "./AuPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__